import type { Organization } from "@src/domain/entities/organization";
import type { IOrganizationRepository } from "@src/domain/repositories/organization";

export interface GetOrganizationDetailsResult {
  organization: Organization;
}

/**
 * Get Organization Details Use Case – fetches a single organization by id with brands and features.
 */
export class GetOrganizationDetailsUseCase {
  private readonly organizationRepository: IOrganizationRepository;

  constructor(organizationRepository: IOrganizationRepository) {
    this.organizationRepository = organizationRepository;
  }

  async execute(organizationId: number): Promise<GetOrganizationDetailsResult> {
    const { data } = await this.organizationRepository.getOrganizationDetails(
      organizationId,
    );
    if (!data?.organizationDetails) throw new Error("Organization not found");
    return { organization: data.organizationDetails };
  }
}
